<template>
  <el-steps :space="300" :active="active" align-center finish-status="success">
    <el-step :title="$t('Pendaftaran')"></el-step>
    <el-step :title="$t('Pendaftaran digisign')"></el-step>
    <el-step :title="$t('Pendaftaran RDL')"></el-step>
  </el-steps>
</template>

<script>
export default {
  name: 'StepsIndividual',
  props: ['active']
}
</script>
